import { PageBlueprint } from '@backstage/frontend-plugin-api';

/**
 * `auth-backend` redirects MCP clients here to approve an OAuth authorization
 * request. The path is fixed by auth-backend, which builds it as
 * `<app.baseUrl>/oauth2/authorize/<sessionId>`.
 *
 * No route ref: nothing in the app links to this page, and a page extension
 * that exposes one also gets a sidebar nav item. The page renders its own
 * `Page`, so the framework header is turned off.
 */
export const consentPage = PageBlueprint.make({
  name: 'oauth-consent',
  params: {
    path: '/oauth2/authorize/:sessionId',
    noHeader: true,
    loader: () => import('./ConsentPage').then(m => <m.ConsentPage />),
  },
});
